import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";

export const StatusTooltip = styled.span`
  display: none;
  padding: 1.5em;
  position: absolute;
  top: -30px;
  left: 9em;
  width: 400px;
  z-index: 100;
  background-color: ${colours.lightGrey};
  border: 1px solid ${colours.highlightGrey};
  border-radius: 3px;
`;

export const StatusContainer = styled.div<{ secretExpired: boolean }>`
  position: relative;
  display: flex;
  color: ${({ secretExpired }): string =>
    secretExpired ? colours.pinkRed : colours.darkOrange};

  p {
    padding-left: 5px;
  }

  &:hover ${StatusTooltip} {
    display: block;
  }
`;

export const StatusLabelContainer = styled.div<{ colour: string }>`
  display: flex;
  align-items: center;
  gap: 0.5em;
  color: ${({ colour }): string => colour};
`;

export const StatusDot = styled.span<{ colour: string }>`
  width: 0.5em;
  aspect-ratio: 1;
  border-radius: 50%;
  background: ${({ colour }): string => colour};
  flex: 0 0 0.5em;
`;

export const SecretsActionCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const DeleteSecretButton = styled(Button)`
  ${resetButtonStyling};
  text-transform: none;
  background: none;
  letter-spacing: normal;
  text-decoration: underline;
  font-weight: bold;
  color: black;
  margin-left: 0.75em;
  text-underline-offset: 4px;
  box-shadow: none;

  &:hover {
    color: ${colours.elexonBlue};
    background: none;
    text-decoration: underline;
  }

  &:active {
    box-shadow: none;
  }

  &:disabled {
    box-shadow: none;
    background: none;
  }

  &&:focus-visible {
    outline: 2px solid ${colours.elexonBlack};
    outline-offset: 4px;
  }
`;
